//Modal for editing a protectee
import React, { useState, useEffect } from 'react'
import ReactDOM from 'react-dom'
import CloseIcon from '@mui/icons-material/Close';
// import './managedAccountModal.scss'
import './modalMain.scss';
import { useNavigate } from 'react-router-dom';
import { fetchAuthSession, getCurrentUser } from 'aws-amplify/auth';


export const EditAccountLogins = ({ isOpen, onClose, id_num, editName, editAccounts }) => {
    //  Need to build out the form to accurately reflect the inputs and values needed. then need to connect the edit function to the backend. 
    //   console.log('edit account opened')
    // const [groupName,setGroupName] = useState('') 
    // let groupName = "test";
    const [edit_name, setName] = useState('None Specified');
    const [edit_dob, setDob] = useState('None Specified');
    const [edit_race, setRace] = useState('None Specified');
    const [edit_gender, setGender] = useState('none');
    const [edit_location, setLocation] = useState('None Specified');
    const [edit_photoUrl, setPhotoUrl] = useState('None Specified');
    const [edit_mainAccount, setMainAccount] = useState('None Specified');
    const [savedAccount, setSavedAccount] = useState("");
    const [savedUsername, setSavedUsername] = useState("");
    const [savedPassword, setSavedPassword] = useState("");
    const [SavedManagedAccount, setSavedManagedAccount] = useState("");
    const [userToken, setUserToken] = useState(null);
    const navigate = useNavigate();

    const getUserToken = async () => {
        try {
            const session = await fetchAuthSession();
            const access_token = session.tokens.accessToken.toString();
            // console.log('Access Tokens',access_token);
            setUserToken(access_token);
            return access_token
        } catch {
            navigate("/login")
        }
    };

    useEffect(() => {
        getUserToken();
    }, [])

    useEffect(() => {
        setName(editName);
        setSavedAccount("");
        setSavedUsername("");
        setSavedPassword("");
        setSavedManagedAccount("");
    }, [onClose])

    // console.log(editName, editDob, editRace, editGender, editLocation, editPhoto, editMainAccount)
    // console.log(name,dob,race,gender,location,photoUrl)
    const handleSubmit = async () => {
        const formData = { SavedManagedAccount, id_num, savedAccount, savedUsername, savedPassword, userToken };

        try {
            const response = await fetch("https://api.weathervaneintel.com/api/api/editmanagedlogin", {
                method: 'POST',
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(formData)
            });

            if (response.status === 403) {
                // Redirect unauthorized user to login
                navigate("/login");
                return; // stop further execution
            }

            if (!response.ok) {
                console.warn("API Error:", response.status, response.statusText);
                return;
            }

            // Only close modal if request succeeded
            onClose();

        } catch (err) {
            console.error("Network or fetch error:", err);
        }
    };

    const handleDelete = async () => {
        const formData = { SavedManagedAccount, id_num, savedAccount, savedUsername, savedPassword, userToken };

        const deleteAnswer = window.confirm(
            "CAUTION!!! \nThis will delete the information for this login. Results from the website will no longer be available. \nAre you sure you want to continue?"
        );

        if (!deleteAnswer) {
            alert('Group not deleted.');
            onClose();
            return;
        }

        try {
            const response = await fetch("https://api.weathervaneintel.com/api/api/deletemanagedlogin", {
                method: 'POST',
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(formData)
            });

            if (response.status === 403) {
                // Redirect unauthorized user to login
                navigate("/login");
                return; // stop further execution
            }

            if (!response.ok) {
                console.warn("API Error:", response.status, response.statusText);
                return;
            }

            // Only close modal if delete succeeded
            onClose();

        } catch (err) {
            console.error("Network or fetch error:", err);
        }
    };

    const showPassword = () => {
        // e.stopPropagation();
        var x = document.getElementById("pwdInput");
        if (x.type === "password") {
            x.type = "text";
        } else {
            x.type = "password";
        }
    }

    const editInfoFunc = (managed_account_num, account, username, password) => {
        setSavedManagedAccount(managed_account_num)
        setSavedAccount(account);
        setSavedUsername(username);
        setSavedPassword(password);
    }

    if (!isOpen) {
        return null
    } else {
        if (userToken === null) {
            return (
                <div className="loadingdiv">
                    <h1>...Loading...</h1>
                </div>
            )
        } else {
            return ReactDOM.createPortal(
                <div className='modalMainContainer'>
                    <div className='modalContainer'>
                        <div className="mainPage">
                            <div className="modalheader">
                                <div className="left">
                                    <h3>Edit Managed Account<br />Login Information:</h3>
                                </div>
                                <div className="right" onClick={onClose}>
                                    <button><CloseIcon /></button>
                                </div>
                            </div>
                            <hr />
                            <div className="splitbody">
                                <div className="top">
                                    <div className="groupform">
                                        {/* <p>{JSON.stringify(editAccounts,null,2)}</p> */}
                                        <table>
                                            <thead>
                                                <tr>
                                                    <th>Account Type</th>
                                                    <th>Username</th>
                                                    <th>Password</th>
                                                    <th>Options</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {editAccounts && editAccounts.map(editAccountInfo => {
                                                    return (
                                                        <tr>
                                                            <td>
                                                                {editAccountInfo.accountName}
                                                            </td>
                                                            <td>
                                                                {editAccountInfo.userName}
                                                            </td>
                                                            <td>
                                                                {/* {editAccountInfo.password} */}
                                                                ***********
                                                            </td>
                                                            <td>
                                                                <button onClick={() => { editInfoFunc(editAccountInfo.managed_account_num, editAccountInfo.accountName, editAccountInfo.userName, editAccountInfo.password) }}>Edit</button>
                                                            </td>
                                                        </tr>
                                                    )
                                                })
                                                }
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <hr />
                                <div className="bottom">
                                    <div className="editinfo">
                                        <div className="modalheader">
                                            <div className="left">
                                                <h3>Edit OR Add Account Login</h3>
                                            </div>
                                            <div className="right-medium">
                                                <button type="checkbox" onClick={() => showPassword()}>Show Password</button>
                                            </div>
                                        </div>
                                        <div className="groupform">
                                            <form>
                                                <div className="formbox">
                                                    <div className="formlabel">
                                                        <label>Account Type</label>
                                                    </div>
                                                    <div className="forminput">
                                                        <input
                                                            type="text"
                                                            name="account type"
                                                            defaultValue={savedAccount}
                                                            onChange={(e) => setSavedAccount(e.target.value)}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="formbox">
                                                    <div className="formlabel">
                                                        <label>Username</label>
                                                    </div>
                                                    <div className="forminput">
                                                        <input
                                                            type="text"
                                                            name="username"
                                                            defaultValue={savedUsername}
                                                            onChange={(e) => setSavedUsername(e.target.value)}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="formbox">
                                                    <div className="formlabel">
                                                        <label>Password</label>
                                                    </div>
                                                    <div className="forminput">
                                                        <input
                                                            type="password"
                                                            name="password"
                                                            id="pwdInput"
                                                            defaultValue={savedPassword}
                                                            onChange={(e) => setSavedPassword(e.target.value)}
                                                        />
                                                    </div>
                                                </div>
                                            </form>
                                            <div className="redButton submitbutton splitbutton">
                                                <button onClick={() => handleSubmit()}>Submit Changes</button>
                                                <button onClick={() => handleDelete()}>Delete</button>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>,
                document.getElementById("portal")
            )
        }
    }
}
